export default __webpack_public_path__ + "static/media/id.fb3d206b.svg";